<style lang="scss" scoped>
@import 'common/sass/reuse.SCSS';
</style>

<template>
  <div :element-loading-text="loadText" class="maintenance-box" v-loading="loading">
    <div class="panel">
      <reuse-table
        :jsonExcelAjax="jsonExcelAjax"
        :name="name"
        :page="page"
        :selPage="selPage"
        :sort="sort"
        :tableHead="tableHead"
        :tbodyData="tbodyData"
        @tableChange="requestEngine"
      >
        <div class="search-box" slot="search">
          <div class="select-type" style="margin-top: 2px;">
            <el-switch :active-text="reuse.moreSelect" inactive-text v-model="more"></el-switch>
          </div>
          <div class="select-type">
            <span v-text="lan.OpenDateText"></span>
            <el-select @change="changeTime" style="width:117px" v-model="type">
              <el-option :key="key" :label="val" :value="key" v-for="(val, key) in reuse.typeMaps"></el-option>
            </el-select>
            <el-date-picker
              :default-time="['00:00:00', '00:00:00']"
              :disabled="canSelect"
              :end-placeholder="lan.endTime"
              :start-placeholder="lan.startTime"
              style="width:230px;"
              type="daterange"
              unlink-panels
              v-model="openTime"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </div>
          <div class="select-type">
            <span v-text="lan.symbolText"></span>
            <el-input clearable style="width:120px;" v-model="symbol"></el-input>
          </div>
          <div class="select-type">
            <span v-text="lan.volumeText"></span>
            <el-input clearable style="width:90px;" v-model="from"></el-input>
            <span style="margin:0 5px;">{{lan.to}}</span>
            <el-input clearable style="width:90px;" v-model="to"></el-input>
          </div>
          <div class="select-type">
            <el-button @click="searchHandle" type="primary" v-text="reuse.searchText"></el-button>
          </div>
        </div>
        <div class="extraSearch" slot="more-filters" v-show="more">
          <div class="searchDiv">
            <span v-text="lan.loginText"></span>
            <el-input clearable style="width:210px;" v-model="login"></el-input>
          </div>
          <div class="searchDiv">
            <span v-text="lan.ibNumText"></span>
            <el-input clearable style="width:210px;" v-model="ibNum"></el-input>
          </div>
          <div class="searchDiv">
            <span v-text="reuse.officeText"></span>
            <el-input clearable style="width:210px;" v-model="office"></el-input>
          </div>
          <div class="searchDiv">
            <span v-text="reuse.regionText"></span>
            <el-input clearable style="width: 210px;" v-model="region"></el-input>
          </div>
          <div class="searchDiv">
            <span v-text="lan.securityText"></span>
            <el-select collapse-tags multiple style="width:210px;" v-model="security">
              <el-option
                :key="key"
                :label="val.TYPE"
                :value="val.TYPE"
                v-for="(val, key) in securityList"
              ></el-option>
            </el-select>
          </div>
        </div>
      </reuse-table>
    </div>
  </div>
</template>

<script>
import { URL_OPENDEAL, URL_TIMEDIFF, URL_SECURITY } from 'api/api'
import reuseTable from 'components/reuseTable'
import { getToDay, getWeekStartAndEnd, getMonthStartAndEnd } from 'common/js/util'

export default {
  mixins: [require('common/mixin/base').base({ lan: 'positionReport' }), require('common/mixin/base').base({ reuse: 'reuse' })],
  data() {
    return {
      loading: false,
      loadText: '',
      page: {
        active: 1,
        pageLeng: 0,
        offset: 0
      },
      selPage: {
        list: ['5', '10', '25', '50'],
        active: 1,
        limit: 10
      },
      sort: {
        list: 'All',
        active: { key: 'Open_Time', order: 'DESC' }
      },
      tbodyData: [],
      more: false,
      from: '',
      to: '',
      login: '',
      ibNum: '',
      office: null,
      region: null,
      symbol: '',
      canSelect: true,
      openTime: [],
      type: '0',
      security: ['ALL'],
      intervalID: '',
      diff: 0,
      securityList: []
    }
  },
  components: {
    reuseTable
  },
  computed: {
    tableHead() {
        const redColorColumns = ['Commission','Swaps','Profit','TOTAL_CLOSE_PL','TOTAL_FLOATING_PL','TOTAL_PL']
        this.lan.tableHead.forEach(head => {
            if(redColorColumns.includes(head.key)) head.redColor = true;
        })
        return this.lan.tableHead
    },
    name() {
        return this.lan.downloadName
    },
    jsonExcelAjax() {
      return {
        url: URL_OPENDEAL,
        ajaxType: 'get',
        getKey: ['data', 'data', 'data'],
        ajaxPar: {
          pageSize: -1,
          pageNum: 0,
          openTime: this.openTime,
          symbol: this.symbol,
          from: this.from,
          to: this.to,
          login: this.login,
          ibNum: this.ibNum,
          office: this.office,
          region: this.region,
          security: this.security,
          sortKey: this.sort.active.key,
          order: this.sort.active.order
        }
      }
    }
  },
  created() {
    this.$http
      .get(URL_TIMEDIFF)
      .then(res => {
        this.diff = res.data.data.diff
        this.openTime = getToDay(this.diff)
        this.$http.get(URL_SECURITY).then(res => {
          if (Object.prototype.toString.call(res.data.data) === '[object Array]') {
            this.securityList = res.data.data
          }
          this.securityList.push({ TYPE: 'ALL' })
          this.requestEngine()
        })
        this.$nextTick(function() {
          this.intervalID = setInterval(this.searchHandle, 6e4)
        })
      })
      .catch(e => {
        alert(this.reuse.serverError)
      })
  },
  destroyed() {
    clearInterval(this.intervalID)
  },
  methods: {
    searchHandle() {
      this.page.active = 1
      this.requestEngine()
    },
    requestEngine() {
      if (!this.openTime) {
        this.$message({ message: this.reuse.selectTimeText, type: 'warning' })
        return
      }
      let paramsArray = ['from', 'to', 'login', 'ibNum', 'office', 'region']
      // 檢查from、to是不是number
      for (let v of paramsArray) if (this[v] && this.tipMessage(this[v])) return

      // 檢查from、to是不是正數
      if (Math.abs(this.from) !== +this.from || Math.abs(this.to) !== +this.to) {
        this.$message({ message: this.lan.plusNumber, type: 'warning' })
        return
      }
      // 檢查手數範圍是不是正確的,to須大於from
      if (this.from && this.to && this.from > this.to) {
        this.$message({ message: this.lan.rightRange, type: 'warning' })
        return
      }
      let option = { params: {} }
      option.params.openTime = this.openTime
      option.params.pageNum = this.page.active
      option.params.pageSize = +this.selPage.limit
      option.params.security = this.security
      paramsArray.push('symbol')
      for (let v of paramsArray) if (this[v]) option.params[v] = this[v]

      if (this.sort.active.order) {
        option.params.sortKey = this.sort.active.key
        option.params.order = this.sort.active.order
      }
      this.loading = true
      this.$http
        .get(URL_OPENDEAL, option)
        .then(res => {
          if (Object.prototype.toString.call(res.data.data.data) === '[object Array]') {
            this.page.pageLeng = res.data.data.count
            this.tbodyData = res.data.data.data
          } else {
            this.tbodyData = []
            this.page.pageLeng = 0
          }
          this.loading = false
        })
        .catch(e => {
          alert(this.reuse.serverError)
        })
    },
    tipMessage(value, key) {
      if (isNaN(new Number(value))) {
        this.$message({
          message: this.reuse.pleaseInputNumber,
          type: 'warning'
        })
        this.tbodyData = []
        this.page.pageLeng = 0
        return true
      }
    },
    changeTime() {
      if (this.type == '3') {
        this.canSelect = false
        return
      }
      this.canSelect = true
      switch (this.type) {
        case '0':
          this.openTime = getToDay(this.diff)
          break
        case '1':
          this.openTime = getWeekStartAndEnd(0, this.diff)
          break
        case '2':
          this.openTime = getMonthStartAndEnd(0, this.diff)
          break
        default:
          break
      }
      this.searchHandle()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/report/position-report.vue